/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// This file exists for easily patching NgModuleFactoryLoader in g3
export default {};



// WEBPACK FOOTER //
// ../../../../../packages/core/src/linker/ng_module_factory_loader_impl.ts